import { useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { liveChatService } from '@/services/liveChat';
import OptionButton from '@/components/OptionButton/OptionButton';
import styles from '@/styles/footer.module.scss';

export default function LiveChatResumeBar() {
  const { t } = useLocalization();
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleResume = async () => {
    setIsLoading(true);
    setHasError(false);

    try {
      await liveChatService.resume();
    } catch (error) {
      setHasError(true);
      console.error('[LiveChat] Failed to resume chat:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.resumeBar}>
      {hasError && (
        <p className={styles.resumeError}>{t('liveChat.resumeError')}</p>
      )}
      <OptionButton
        variant="primary"
        className={styles.resumeBtn}
        onClick={handleResume}
        disabled={isLoading}
      >
        {isLoading ? t('liveChat.resuming') : t('liveChat.resume')}
      </OptionButton>
    </div>
  );
}
